'use strict';

class HttpInterceptor {
  constructor() {
    ['request', 'requestError', 'response', 'responseError'].forEach((method) => {
      if (this[method]) {
        this[method] = this[method].bind(this);
      }
    });
  }
}

class AuthService extends HttpInterceptor {
  constructor($q, $window, $location, I18N) {
    super();

    this.$q = $q;
    this.$window = $window;
    this.$location = $location;
    this.I18N = I18N;
  }

  /**
   * REQUEST
   *
   * @param {Object} req Request object
   * @returns {Object} The modified request object
   */
  request(req) {
    req.headers = req.headers || {};

    // set originator
    const originatorId = this.$window.sessionStorage.getItem('originatorId');
    if (originatorId) {
      req.headers['Originator-Id'] = originatorId;
    }

    // update referer header
    req.headers['Client-Referer'] = this.$location.absUrl();

    // set default headers
    req.headers['End-User-Message'] = true;
    req.headers['API-Version'] = '1.0';
    req.headers.Client = 'browser';

    return req;
  }

  /**
   * RESPONSE - PASS
   *
   * @param {Object} resp Response object
   * @returns {Object} The modified response
   */
  response(resp) {
    // Handle 204 to do not return empty string as body
    if (resp.status === 204 && resp.data === '') {
      resp.data = null;
    }

    return resp || this.$q.when(resp);
  }

  /**
   * Generate error message
   *
   * @param {String} text Text to display as error
   * @param {Array} errors Errors on the JSON
   */
  displayError(text, errors) {
  let dom = $('[ng-view]').length ? '[ng-view]' : '.page';

    $('.alert-box.system').remove();
    $(dom).prepend(`<div class="alert-box error system">${text}</div>`);

    if (errors && errors.length) {
      let list = '';

      errors.forEach((e) => {
        const $inp = $(`input[name="${e.name}"], textarea[name="${e.name}"], select[name="${e.name}"]`);

        // mark input
        if ($inp.length) {
          $inp
            .prop('placeholder', '')
            .removeClass('ng-pristine').removeClass('ng-untouched')
            .addClass('ng-dirty').addClass('ng-touched').addClass('error');

          // add color to label
          if ($inp.prev().is('label')) {
            $inp.prev().addClass('error');
          }

          // show message if not there already
          if (!$inp.next('span.error:visible').length) {
            $inp.after(`<span class="error">${e.endUserMessage}</span>`);
          }
        } else {
          list += `<li>${e.endUserMessage} <span style="color: #666;">[${this.getI18Prop(e.name)}]</span></li>`;
        }
      });

      if (list.length) {
        $('.alert-box.system').append(`<ul style="margin: 5px 0 0 20px;">${list}</ul>`);
      }
    }
  }

  getI18Prop(prop) {
    let propFixed = prop.replaceAll('.', '_');
    let res = this.I18N.fields[propFixed];
    if (res === undefined) {
      return prop;
    }
    return res;
  }

  /**
   * Handle error 403
   *
   * @param {Object} reject
   */
  error403(reject) {
    const err = reject.data && reject.data.errors && reject.data.errors[0] ? reject.data.errors[0].name : [];

    if (err === 'PASS_CHANGE_REQUIRED') {
      this.$window.location.href = reject.headers().location;
    } else if (err === 'OTP_REQUIRED') {
      this.$window.location.href = '/side/#/bekrefte';
    } else if (err === 'TOO_MANY_LOGIN_ATTEMPTS' || err === 'CLOSED_ACCOUNT') {
      this.$window.sessionStorage.removeItem('systemError');
      this.$window.sessionStorage.setItem('systemError', angular.toJson(reject.data));
      this.$window.location.href = '/side/#/feil';
    } else if (err === 'ACCOUNT_NOT_FOUND' || err === 'NO_ORIGINATOR_SELECTED') {
      this.$window.location.href = '/side/#/bytt-konto';
    } else if (err === 'MISSING_PAYMENT') {
      // STATE 2
      this.$window.location.href = '/side/#/feil/stengt';
    } else {
      this.$window.sessionStorage.removeItem('systemError');
    }
  }

  /**
   * RESPONSE - FAIL
   *
   * @param {Object} reject The reject object
   * @returns {Object}
   */
  responseError(reject) {
    const statuses = {
      401: () => {
        if (!reject.config.ignoreAuth) {
          this.$window.sessionStorage.removeItem('originatorId');

          if (reject.config.url !== '/logg-inn/' || reject.config.url !== '/registrer/') {
            this.$window.location.href = '/logg-inn/';
          }
        }
      },
      403: () => {
        this.error403(reject);
      },
      404: () => {},
      412: () => {},
      500: () => {
        this.displayError('Intern systemfeil');
      },
      503: () => {
        this.displayError('SendRegning er midlertidig utilgjengelig, vennligst prøv igjen om noen minutter.');
      }
    };

    if (reject.status && reject.status in statuses) {
      statuses[reject.status]();
    } else {
      if (reject.data && reject.data.endUserMessage) {
        this.displayError(reject.data.endUserMessage, reject.data.errors);
      } else {
        //causing random message to appear
        if (reject.status !== -1) {
          this.displayError(this.I18N.general.systemError);
        }
      }
    }

    return this.$q.reject(reject);
  }
}

AuthService.$inject = ['$q', '$window', '$location', 'I18N'];

angular
  .module('SendRegning')
  .service('auth', AuthService);
